import { Form, Input, Select } from 'antd';
import { v4 as uuid } from 'uuid';
import ArrowIcon from '../../../../../assets/images/catalogue/arrowIcon';
import { IProductDetailId } from '../../../../../types/products';
import { FC, useEffect, useState } from 'react';
import { getSpecsLists } from '../../../../../services/cataloge';
import { ISpecs } from '../../../../../types/category';
import GeneralInfoSkeleton from '../../../../../components/formLoaders/generalInfo/GeneralInfoSkeleton';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

interface IMonitors {
  productDataDetail?: IProductDetailId;
  setVerifySpecs: (isVerify: boolean) => void;
}
const Monitors: FC<IMonitors> = ({ productDataDetail, setVerifySpecs }: IMonitors) => {
  const { Option } = Select;
  const [listResolution, setListResolution] = useState<ISpecs>();
  const [loading, setLoading] = useState<boolean>(false);
  const displayInches = Form.useWatch('displayInches');
  const pixels = Form.useWatch('pixels');
  const resolution = Form.useWatch('resolution');
  const fps = Form.useWatch('fps');

  const getDataForm = async () => {
    setLoading(true);
    try {
      const resolutionData = await getSpecsLists('tipoHD');
      setListResolution(resolutionData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      displayErrorNotification();
    }
  };

  const verifyGroup = () => {
    if (displayInches && pixels && fps) {
      setVerifySpecs(true);
    } else {
      setVerifySpecs(false);
    }
  };
  useEffect(() => {
    verifyGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayInches, pixels, resolution, fps]);

  useEffect(() => {
    getDataForm();
  }, []);

  return (
    <>
      {loading ? (
        <GeneralInfoSkeleton />
      ) : (
        <>
          <div className="firstSection">
            <div className="mediumItem">
              <div className="titleForm">Pantalla</div>
              <Form.Item
                initialValue={productDataDetail?.displayInches}
                name="displayInches"
                rules={[{ required: true, message: 'campo requerido' }]}
              >
                <Input className="inputTabs" placeholder="Ej. 15”" />
              </Form.Item>
            </div>
            <div className="mediumItem">
              <div className="titleForm">Resolución</div>
              <Form.Item
                name="pixels"
                initialValue={productDataDetail?.pixels}
                rules={[{ required: true, message: 'campo requerido' }]}
              >
                <Input className="inputTabs" placeholder="Ej. 1920x1080 " />
              </Form.Item>
            </div>
            <div className="mediumItem">
              <div className="titleForm">{'Tipo HD (Opcional)'}</div>
              <div className="customSelectAnt">
                <Form.Item>
                  <Form.Item initialValue={productDataDetail?.resolution} noStyle name="resolution">
                    <Select
                      className="customStyle"
                      placeholder="Ej. 4K"
                      suffixIcon={<ArrowIcon className="rotateIcon" />}
                    >
                      {listResolution &&
                        listResolution.value &&
                        listResolution.value.map(item => {
                          return (
                            <Option key={uuid()} value={item}>
                              {item}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="secondSection">
            <div className="mediumItem">
              <div className="titleForm">Frecuencia</div>
              <Form.Item
                initialValue={productDataDetail?.fps}
                name="fps"
                rules={[{ required: true, message: 'campo requerido' }]}
              >
                <Input className="inputTabs" placeholder="Ej. 60 Hz" />
              </Form.Item>
            </div>
            <div className="mediumItem">
              <div className="titleForm">Color (opcional)</div>
              <Form.Item initialValue={productDataDetail?.color} name="color">
                <Input className="inputTabs" placeholder="Ej. Negro" />
              </Form.Item>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Monitors;
